module.exports = __webpack_public_path__ + "74861e5bf4b695d069c48abc540aec03.svg";